import React from 'react';
import MapPointsWorkspace from '../features/map-points/MapPointsWorkspace';

const MapPoints = () => {
  return <MapPointsWorkspace />;
};

export default MapPoints;
